var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedln = function SvgLinkedln(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 2.66634C4.00065 3.40272 3.4037 3.99967 2.66732 3.99967C1.93094 3.99967 1.33398 3.40272 1.33398 2.66634C1.33398 1.92996 1.93094 1.33301 2.66732 1.33301C3.4037 1.33301 4.00065 1.92996 4.00065 2.66634Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 5.66634V14.6663H1.33398V5.66634H4.00065Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 5.66634H8.66732V6.22728C9.08436 6.07988 9.53314 5.99967 10.0007 5.99967C12.2098 5.99967 14.0007 7.79054 14.0007 9.99968V14.6663H11.334V9.99967C11.334 9.26329 10.737 8.66634 10.0007 8.66634C9.26427 8.66634 8.66732 9.26329 8.66732 9.99967V14.6663H6.00065V5.66634Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedln);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "linkedln.7dba5a48813a2d8b26abc91803d82914.svg";